import { NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'sl-error-summary',
    templateUrl: './error-summary.component.html',
    styleUrls: ['./error-summary.component.less'],
    standalone: true,
    imports: [NgIf, NgFor],
})
export class ErrorSummaryComponent {
	@Input() headerText = 'Please correct the following issues:';
	// set headerText(headerText: string) {
	// 	this.headerText = headerText || 'Please correct the following issues:';
	// }

	@Input() errors: string[] = [];

	// constructor() {

	// }
}
